/**
 * Re-evaluation note — the free text whoever asks for a second assessment can
 * attach, saying what the first reading got wrong.
 *
 * One source of truth for the cap, because it is enforced in four places that
 * must agree: the request schema, the persisted `AssessmentVersion`, and the
 * `maxLength` on the student and teacher/admin text boxes. A client that allows
 * more than the server accepts turns a helpful note into a failed re-evaluation.
 *
 * See docs/FeatureDesigns/solution-analysis/reevaluation-note.md.
 */

/** Long enough for two or three sentences of pointing at the work; short enough
 *  to keep the prompt-injection surface and the prompt-cache impact small. */
export const REEVAL_NOTE_MAX_LENGTH = 500;

/** Who wrote the note. Decides how much a claim about ambiguous handwriting is
 *  worth — a teacher reading it is more reliable than the student whose score
 *  depends on the reading. Mirrors `AssessmentVersion.triggeredBy` minus
 *  'system' (no automated re-run writes a note). */
export type ReEvalNoteAuthor = 'student' | 'teacher' | 'admin';
